import React, { useEffect } from "react";
import Infrastructure from "./Infrastructure";
import Hero from "./hero";
import Cards from "./Cards";


function Index() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            <Hero />
            <Infrastructure />
            <Cards />
        </div>
    );
}

export default Index;